"use client";

import { c as _c } from "react/compiler-runtime";
import { Image } from "@opensea/next-ui-kit";
import { CenterAligned, classNames, SpaceBetween, scaleTransformVariants, TextBody, TextHeading } from "@opensea/ui-kit";
export function OnboardingSelectOption(t0) {
  const $ = _c(13);
  const {
    option,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("w-full md:w-1/3", "gap-4 p-4 md:gap-6 md:p-6", "basis-auto cursor-pointer flex-col", "inset-shadow-border rounded-lg backdrop-blur-md", "hover:inset-shadow-border hover:bg-bg-additional-1/40", scaleTransformVariants(), "transition duration-1000 ease-out-quint");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== option.title) {
    t2 = <SpaceBetween><TextHeading size="sm">{option.title}</TextHeading></SpaceBetween>;
    $[1] = option.title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== option.image) {
    t3 = <div className="relative aspect-[580/326] w-full rounded-lg bg-bg-additional-1"><Image className="object-contain" fill={true} sizes="auto" src={option.image} /></div>;
    $[3] = option.image;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== option.description) {
    t4 = option.description ? <CenterAligned><TextBody className="text-left text-sm opacity-80">{option.description}</TextBody></CenterAligned> : null;
    $[5] = option.description;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onSelect || $[8] !== option.id || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <SpaceBetween className={t1} data-testid={option.id} onClick={onSelect}>{t2}{t3}{t4}</SpaceBetween>;
    $[7] = onSelect;
    $[8] = option.id;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}